import { Divider, Grid, Typography } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SiNoChip } from "src/pages/sistema/components/FieldView";
import { ADCMTransaccionTipo } from "../types/enum";
import { OperacionADCMFields } from "../types/fields";
import { numberFormatter } from "src/utils/formatters/numberFormatter";

type SeccionADCMDetalleTransaccionProps = {
  operacion?: any;
}

const SeccionADCMDetalleTransaccion = ({ operacion }: SeccionADCMDetalleTransaccionProps) => {
  const watchedVirtual = operacion?.[OperacionADCMFields.CodVirtualTransaccion];
  const esDCMoABS = watchedVirtual === ADCMTransaccionTipo.DCM || watchedVirtual === ADCMTransaccionTipo.ABS;
  const esECM = watchedVirtual === ADCMTransaccionTipo.ECM;
  const esABS = watchedVirtual === ADCMTransaccionTipo.ABS;
  const mostrarSeccion = esDCMoABS || esECM;

  if (!operacion || !mostrarSeccion) return null;

  return (
    <CardActions title='Detalle de la Transacción' icon='mdi:swap-horizontal' colapsable>
      <Grid container spacing={2.5} rowSpacing={2.5}>

        {/* Datos financieros base */}
        <Grid item xs={12} >
          <FieldView
            label='Monto'
            value={operacion[OperacionADCMFields.Monto]
              ? numberFormatter.toStringWithAmount(operacion[OperacionADCMFields.Monto], '$', 0)
              : undefined}
          />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Tipo de Moneda' value={operacion[OperacionADCMFields.Moneda]} />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Fee' value={operacion[OperacionADCMFields.Fee]} />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Destino de fondos' value={operacion[OperacionADCMFields.DestinoFondos]} />
        </Grid>

        {/* Estructura de deuda (DCM y ABS) */}
        {esDCMoABS && (
          <>
           
            <Grid item xs={12} >
              <FieldView label='Cupón de la transacción' value={operacion[OperacionADCMFields.CuponTransaccion]} />
            </Grid>
            <Grid item xs={12} >
              <FieldView label='Cadencia de pago de cupón' value={operacion[OperacionADCMFields.CadenciaPagoCupon]} />
            </Grid>
            <Grid item xs={12} >
              <FieldView label='Plazo al vencimiento' value={operacion[OperacionADCMFields.PlazoVencimiento]} />
            </Grid>
            <Grid item xs={12} >
              <FieldView label='Cadencia de amortización' value={operacion[OperacionADCMFields.CadenciaAmortizacion]} />
            </Grid>
            <Grid item xs={12} >
              <FieldView label='Cadencia de amortización' value={operacion[OperacionADCMFields.ContratoExclusividad]} />
              
            </Grid>
            <Grid item xs={12} md={9}>
              <FieldView label='Co-colocadores' value={operacion[OperacionADCMFields.Colocadores]} />
            </Grid>
          </>
        )}

        {/* Garantías (ABS) */}
        {esABS && (
          <>
            <Grid item xs={12}>
              <Divider textAlign='left'>
                <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                  Garantías
                </Typography>
              </Divider>
            </Grid>
            <Grid item xs={12}>
              <FieldView label='Garantías' value={operacion[OperacionADCMFields.Garantias]} />
            </Grid>
          </>
        )}

      </Grid>
    </CardActions>
  );
};

export default SeccionADCMDetalleTransaccion;
